import React from 'react';
import {View} from 'react-native';
import {Field} from 'redux-form';
import {BaseField} from '../../../../../shared/components/baseField';
import {useStyles} from '../../../../../shared/hooks/styles';
import {IStateProps} from './model';
import {Button} from '../../../../../shared/components/button';
import {Form} from '../../../../../shared/components/form';

export default ({handleSubmit}: IStateProps) => {
  const styles = useStyles(() => ({
    fieldWrap: {
      marginBottom: 15,
    },
    button: {
      width: 240,
      marginTop: 50,
      marginHorizontal: 'auto',
    },
    eyeContainer: {
      width: 40,
      height: 40,
      paddingTop: 16,
      display: 'flex',
      alignItems: 'flex-end',
    },
  }));

  return (
    <Form onSubmit={handleSubmit}>
      <View style={styles.fieldWrap}>
        <Field
          autoFocus
          type='password'
          name='oldPassword'
          component={BaseField}
          label='Текущий пароль'
          onSubmitEditing={handleSubmit}
        />
      </View>
      <View style={styles.fieldWrap}>
        <Field
          type='password'
          name='newPassword'
          component={BaseField}
          label='Новый пароль'
          onSubmitEditing={handleSubmit}
        />
      </View>
      <View style={styles.fieldWrap}>
        <Field
          type='password'
          name='confirmPassword'
          component={BaseField}
          label='Повторите пароль'
          onSubmitEditing={handleSubmit}
        />
      </View>
      <Button
        id='profile-change-password-save'
        style={styles.button}
        type='primary'
        onPress={handleSubmit}
        text='Сохранить'
      />
    </Form>
  );
};
